import { IUserPlayer } from "@grassrootly/api";
import { FormBuilderType, FormBuilderValidator } from "@grassrootly/rn-core";

export interface EditProfileProps {
  player: IUserPlayer;
  onEditFinished: () => void;
}

export interface IProfileForm {
  name: string;
}

export const profileForm: FormBuilderType<IProfileForm> = {
  name: {
    type: "input",
    name: "name",
    label: "Name",
    defaultValue: "",
    validators: [FormBuilderValidator.required(), FormBuilderValidator.minChar(3)],
    required: true,
    props: {
      keyboardType: "name-phone-pad",
    },
  },
};
